<template>
    <div class="chat-bot" :class="{ chatting }">
        <div class="avatar" @click="openChat"></div>
        <div class="chat-penal">
            <div class="container">
                <div class="messages" ref="messages">
                    <template v-if="messages.length">
                        <div v-for="(item, index) in messages" v-if="item.role !== 'default'" :class="item.role"
                             :key="index">
                            <e-markdown :content="item.content"></e-markdown>
                            <el-avatar class="user-avatar" size="medium"
                                       :src="avatar"
                                       v-if="item.role === 'user'">{{ username }}
                            </el-avatar>
                        </div>
                    </template>
                    <div class="assistant" v-if="loading">
                        <div>
                            <span class="el-icon-loading"></span>
                        </div>
                    </div>
                </div>
                <div class="input">
                    <el-input placeholder="请输入内容" v-model="inputValue" size="small" style="margin-right: 10px"
                              :disabled="loading"></el-input>
                    <el-button type="success" icon="el-icon-s-promotion" size="mini" @click="sendMessage()">
                        发送
                    </el-button>
                    <el-button icon="el-icon-brush" size="mini" @click="clearMessage">清除对话</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

const url = 'https://gateway.neolink-ai.com/byoa/api/v1/agents/chat_public'
const deployUrlSuffix = 'AAekqCwuVtUUePVNDDhGnsYWEaedaBdcRbR300001'

export default {
    name: 'chatBot',
    props: {
        avatar: String,
        username: String
    },
    watch: {
        messages: {
            handler () {
                this.$nextTick(() => {
                    this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
                })
            },
            deep: true
        }
    },
    methods: {
        openChat () {
            this.chatting = !this.chatting
        },
        sendMessage (value, role = 'user') {
            if (value !== '' || this.inputValue !== '') {
                this.messages.push({
                    role: role,
                    content: value || this.inputValue
                })
                this.inputValue = ''
                this.loading = true

                axios
                    .post(
                        url,
                        JSON.stringify({
                            deploy_url_suffix: deployUrlSuffix,
                            messages: this.messages
                        }),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    )
                    .then(res => {
                        this.messages.push({
                            role: 'assistant',
                            content: res.data
                        })
                    })
                    .catch(() => {
                        this.messages.push({
                            role: 'assistant',
                            content: '很抱歉，似乎出了点问题……'
                        })
                    })
                    .finally(() => this.loading = false)
            }
        },
        clearMessage () {
            this.inputValue = ''
            this.$set(this, 'messages', [])
            this.start()
        },
        start () {
            this.sendMessage('你好', 'default')
        }
    },
    data () {
        return {
            loading: false,
            chatting: false,
            inputValue: '',
            messages: []
        }
    },
    mounted () {
        this.start()
    }
}
</script>

<style scoped>
.chat-bot {
    width: 80px;
    height: 80px;
    position: fixed;
    right: 20px;
    bottom: 20px;
    transition: all ease-in-out 250ms;
    z-index: 100000;
}

.chat-bot.chatting {
    width: 600px;
    height: 520px;
}

.chat-penal {
    width: 0;
    height: 0;
    opacity: 0;
    padding: 10px 15px;
    background: #fff;
    box-shadow: 0 0 20px 0 #4a4a4a;
    border-radius: 4px;
    position: absolute;
    z-index: 1;
    top: 40px;
    left: 40px;
}

.chat-penal .container {
    width: 100%;
    height: 100%;
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.chat-penal .messages {
    max-height: calc(100% - 42px);
    height: fit-content;
    display: flex;
    flex-direction: column;
    overflow: auto;
    scrollbar-width: none
}

.chat-penal .messages::-webkit-scrollbar {
    display: none;
}

.chat-penal .messages > div {
    display: flex;
    align-items: center;
    margin: 5px 0;
}

.chat-penal .messages > div > div {
    width: fit-content;
    max-width: 80%;
    padding: 5px 10px;
    border: 1px solid #b0a3ff;
    border-radius: 4px;
}

.chat-penal .messages > div.user .user-avatar {
    margin-left: 5px;
}

.chat-penal .messages > div.user {
    justify-content: flex-end;
}

.chat-penal .messages > div.user > div {
    color: #fff;
    border-color: #5F49E6;
    background: #5F49E6;
}

.chat-penal .input {
    padding-top: 10px;
    display: flex;
    align-items: center;
}

.avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #fff url(../../assets/bot.svg) center / 70% no-repeat;
    box-shadow: 0 0 5px 0 #4a4a4a;
    transform: scale(0.8);
    transition: all ease-in-out 180ms;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    cursor: pointer;
}

.avatar:hover {
    box-shadow: 0 0 15px 0 #4a4a4a;
    transform: scale(1.1);
    transition-delay: 100ms;
}

.chat-bot.chatting .avatar {
    box-shadow: 0 0 10px 0 #4a4a4a;
    transform: scale(1);
}

.chat-bot.chatting .chat-penal {
    animation: expand ease-out 250ms forwards;
    animation-delay: 300ms;
}

.chat-bot.chatting .chat-penal .container {
    animation: show-opacity ease-out 180ms forwards;
    animation-delay: 600ms;
}

@keyframes expand {
    0% {
        width: 0;
        height: 0;
        opacity: 0;
    }
    100% {
        width: calc(100% - 40px);
        height: calc(100% - 40px);
        opacity: 1;
    }
}

@keyframes show-opacity {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.el-icon-loading {
    color: #9E9E9E;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/chatBot.vue